
export default function NeoAssist() {
  return <div id="NeoassistCentral"></div>
}
